import { TransferFile } from './transfer-file.model';
import { User } from '../users/user.model';

import * as moment from 'moment';

export class Transfer {

  deliveryDate: moment.Moment;
  downloaded: boolean = false;
  expirationDate: moment.Moment;
  expired: boolean = false;
  files: TransferFile[] = [];
  metadata: any;
  notes: string;
  notifications: string[] = [];
  uploadPackageGuid: string;
  uploadPackageId: number;
  priority: number = 1;
  progress: number = 0; // percentage 0 to 100
  recipients: User[] = [];
  requestId: string;
  senderEmail: string;
  senderId: string;
  senderFirstName: string;
  senderLastName: string;
  size: number = 0;
  status: string = "pending";
  templateId: number;
  workflowId: number;
  workflowType: string;

  get isExpired(): boolean {
    return (this.expired || (this.expirationDate && this.expirationDate < moment()))
  }
  get senderName(): string {
    if (this.senderFirstName == null && this.senderLastName == null) {
      return null
    } else {
      return [this.senderFirstName, this.senderLastName].join(" ")
    }
  }

  get sender(): string {
    let value = this.metadata["sender"];
    if (value != null) {
      return value.map((v) => v.displayed).join(', ');
    }
  }

  public constructor(init?:Partial<Transfer>) {
    Object.assign(this, init);
  }

  static fromPackageRecord(record) {
    let transfer = new Transfer();
    transfer.uploadPackageGuid = record.package_guid;
    transfer.senderId = (''+record.user_id).toLowerCase();
    transfer.senderEmail = record.user_email;
    transfer.senderFirstName = record.user_first;
    transfer.senderLastName = record.user_last;
    transfer.deliveryDate = moment(record.delivery_date);
    transfer.notes = record.delivery_notes;
    transfer.size = record.package_size;
    transfer.downloaded = (record.download_status === 'Downloaded');

    let deliveries = record.deliveries || record.delivery
    let first = deliveries[0]

    transfer.priority = first.priority || first.dh_priority || first.dhPriority;
    transfer.metadata = this.flattenMetadata(first.metadata);

    let expiration = first.expiration_date || first.dh_expiration_date;
    transfer.expirationDate = expiration != null ? moment(expiration) : null;

    let recipients = first.recipients;
    transfer.recipients = recipients.map((r) => User.fromRecord(r))

    transfer.files = deliveries.map((d) => TransferFile.fromRecord(d));
    transfer.expired = this.overallExpired(transfer.files);
    transfer.status = this.overallStatus(transfer.files);

    transfer.workflowId = transfer.metadata['workflow_id'] != null ? transfer.metadata['workflow_id'][0]['stored'] : null;
    let templateId = transfer.metadata['template_id'] != null ? transfer.metadata['template_id'][0]['stored'] : null;
    transfer.templateId = templateId != null && templateId != '' ? templateId : null;

    return transfer;
  }

  static fromDeliveryRecord(record) {
    let transfer = new Transfer();

    let first = record[0];
    transfer.expired = (first.dh_expired === true);
    transfer.expirationDate = moment(first.dh_expiration_date, 'YYYY-MM-DD hh:mm:ss');

    let packages = first.packages
    transfer.uploadPackageGuid = packages.package_guid;
    transfer.notes = packages.delivery_notes;
    transfer.deliveryDate = moment(packages.delivery_date, 'YYYY-MM-DD hh:mm:ss');

    let sender = first.users
    transfer.senderId = (''+sender.user_id).toLowerCase();
    transfer.senderEmail = sender.user_email;
    transfer.senderFirstName = sender.user_first;
    transfer.senderLastName = sender.user_last;

    let recipients = first.recipients;
    transfer.recipients = recipients.map((r) => User.fromRecord(r.users))

    let metadata = first.metadata != null && first.metadata.md_metadata_object != null ?
     JSON.parse(first.metadata.md_metadata_object) : null;
    transfer.metadata = this.flattenMetadata(metadata);

    transfer.files = record.map((d) => TransferFile.fromRecord(d));
    transfer.expired = this.overallExpired(transfer.files);
    transfer.status = this.overallStatus(transfer.files);

    transfer.workflowId = transfer.metadata['workflow_id'] != null ? transfer.metadata['workflow_id'][0]['stored'] : null;
    let templateId = transfer.metadata['template_id'] != null ? transfer.metadata['template_id'][0]['stored'] : null;
    transfer.templateId = templateId != null && templateId != '' ? templateId : null;

    return transfer;
  }

  static flattenMetadata(data) {
    let metadata = {};
    if (data == null) { return metadata }

    let object = data.metadata_object != null ? data.metadata_object : {};
    let fields = object.fields != null ? object.fields : [];

    for (let field of fields) {
      if (metadata[field.field_id] == undefined) {
        metadata[field.field_id] = field.field_values;
      }
    }

    return metadata;
  }

  static overallExpired(files) {
    return files.length > 0 && files.find((f) => !f.expired) == null;
  }

  static overallStatus(files) {
    return files.reduce((status, file) => {
      if (file.status !== "completed") {
        if (status === "completed" || TransferFile.statusCodes[file.status] > TransferFile.statusCodes[status]) {
          status = file.status;
        }
      }
      return status;
    }, "completed")
  }

  isSender(userId: string) {
    if (userId == null) { return false }
    return (this.senderId.toLowerCase() === userId.toLowerCase())
  }

  isRecipient(userId: string) {
    if (userId == null) { return false }
    userId = userId.toLowerCase()
    return (this.recipients.find((r) => r.id.toLowerCase() === userId) != null)
  }

}



// WEBPACK FOOTER //
// ./src/app/transfers/transfer.model.ts